var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10237_65014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 28.6667L24.4581 24.4581M24.4581 24.4581C25.5138 23.4025 26.1667 21.9442 26.1667 20.3333C26.1667 17.1117 23.555 14.5 20.3333 14.5C17.1117 14.5 14.5 17.1117 14.5 20.3333C14.5 23.555 17.1117 26.1667 20.3333 26.1667C21.9442 26.1667 23.4025 25.5138 24.4581 24.4581ZM17.8333 20.3333H22.8333M20.3333 17.8333V22.8333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10237_65014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.118ee19b2788653200c78cbcd0258964.svg";
export { ForwardRef as ReactComponent };